export enum InvestmentObjective {
  CAPITAL_PRESERVATION = 'Capital Preservation',
  INCOME = 'Income',
  GROWTH_AND_INCOME = 'Growth & Income',
  GROWTH = 'Growth',
  SPECULATION = 'Speculation',
}
